module.exports = __webpack_public_path__ + "media/images/arrow-horizontal-c31de16fc03d6454e544918e04c56640.svg";